export const hallowGreyCircle = "Fullkit not ready, task start date > today";
export const hallowRedCircle = "Fullkit not ready, task start date =< today";
export const inProgressLate = "In-progress - late";
export const redCross = "Job rejected - until Rework is initiated";
export const greenV = "Job completed";
export const hallowGreenCircle = "Fullkit ready";
export const solidGreenCircle = "In-progress (fullkit was already ready)";
export const NA = "Design: No design stage for this FA [or] CIC: CIC Needed = 'CIC Dependent' or 'Not Needed'";

export const UnallocatedHallowGreyCircle = "Stage not started";
export const UnallocatedSolidGreenCircle = "Stage in progress";
export const UnallocatedNA = "Not Applicable";